// extracted by mini-css-extract-plugin
export default {"termsAndConditions":"TermsAndConditions_termsAndConditions__aBckH","menu":"TermsAndConditions_menu__JglUs"};